module.exports = __webpack_public_path__ + "img/1454450386.d63b9529.jpg";